import { useContext } from 'react'

import { CreatorStateContext } from '../state/CreatorProvider'
import type { CreatorContext } from '../types'

export const useCreators = (): CreatorContext => {
  const context = useContext(CreatorStateContext)

  if (context === undefined) {
    throw new Error('useCreators must be used within CreatorProvider')
  }

  return context
}
